export default "is\nor\nwhere\nwhat\nhow\nhow many\nhow much\nshould\ncan"